import React from 'react';
import './LibelleNouveauMarche.css';

export type FormeMarche = 'BC' | 'MS';

/**
 * Libelle des boutons de creation de marche, sur deux lignes : l'action, puis la nature de la
 * prestation en plus petit.
 *
 * Centralise ICI et non recopie sur chaque bouton : ces boutons vivent sur quatre ecrans (Catalogue,
 * Operation, Commandes, modale d'articles) et le libelle y divergeait deja — « Bon de commande » ou
 * « Bon de Commande » selon la page. Une seule source rend la formulation reparable en un point.
 */
const LIBELLE: Record<FormeMarche, { action: string; precision: string }> = {
  BC: { action: 'Nouveau Bon de commande', precision: '(Prestations sur catalogue)' },
  MS: { action: 'Nouveau Marché subséquent', precision: '(Prestations sur-mesure)' },
};

interface LibelleNouveauMarcheProps {
  forme: FormeMarche;
}

const LibelleNouveauMarche: React.FC<LibelleNouveauMarcheProps> = ({ forme }) => (
  <span className="libelle-nouveau-marche">
    <span>{LIBELLE[forme].action}</span>
    <span className="libelle-nouveau-marche__precision">{LIBELLE[forme].precision}</span>
  </span>
);

export default LibelleNouveauMarche;
